<template>
	<div id="vue-modal-template" v-if="show">
    <transition name="vue-modal">
      <div class="vue-modal-mask" @click="closeModal()">
        <div class="vue-modal-wrapper" >

					<div class="container vue-modal-container" @click.stop.prevent>
						<div class="vue-modal-close">
							<button @click="closeModal()" class="btn btn-secondary btn-xs"><i class="fa fa-close"></i></button>
						</div>
						<div class="scroll">
							<div v-if="type == 'C' || type == 'S' || type == 'D'" 
								class="scroll-icon fa fa-chevron-down">
							</div>

	        	 	<ficha-extendida-cine 
	        			v-if="type == 'C'"
	        			:productID = "productID"
	        			:miSeleccion = "miSeleccion"
	        			:contenedor = "contenedor">	
	        		</ficha-extendida-cine>

	        		<ficha-extendida-musica 
	        			v-if="type == 'M'"
	        			:productID = "productID"
	        			:miSeleccion = "miSeleccion"
	        			:contenedor = "contenedor">
	        		</ficha-extendida-musica>

	        		<ficha-extendida-libros 
	        			v-if="type == 'L'"
	        			:productID = "productID"
	        			:miSeleccion = "miSeleccion"
	        			:contenedor = "contenedor">
	        		</ficha-extendida-libros>

	        		<ficha-extendida-series 
	        			v-if="type == 'S'"
	        			:productID = "productID"
	        			:miSeleccion = "miSeleccion"
	        			:contenedor = "contenedor">
	        		</ficha-extendida-series>

	        		<ficha-extendida-documentales 
	        			v-if="type == 'D'"
	        			:productID = "productID"
	        			:miSeleccion = "miSeleccion"
	        			:contenedor = "contenedor">
	        		</ficha-extendida-documentales>

	        		<br>

	            <div class="bottom-close">
	              <button @click="closeModal()" class="btn">{{ $t('Cerrar') }}</button>
	            </div>		

						</div>	
          </div>
        </div>
      </div>
  	</transition>
  </div>
</template>

<i18n>
{
  "es": {
    "Cerrar": "Cerrar"
  },
  "en": {

  },
  "ca": {
    "Cerrar": "Tancar"
  }
}
</i18n>

<script>
	import FichaExtendidaCine from './FichaExtendidaCine.vue';
	import FichaExtendidaMusica from './FichaExtendidaMusica.vue';
	import FichaExtendidaLibros from './FichaExtendidaLibros.vue';
	import FichaExtendidaSeries from './FichaExtendidaSeries.vue';
	import FichaExtendidaDocumentales from './FichaExtendidaDocumentales.vue';

	export default {
	  props:['show', 'type', 'productID', 'miSeleccion', 'contenedor'],
	  components: { FichaExtendidaCine, FichaExtendidaMusica, FichaExtendidaLibros, FichaExtendidaSeries, FichaExtendidaDocumentales },
		data: () => {
			return{
	      producto: ""
			}
		},
	  mounted(){
	  	document.addEventListener("keydown", (e) => {
	      if (this.show && e.keyCode == 27) {
	        this.closeModal();
	      }
    	});
	  },
	  methods:{
	  	closeModal(){
	  		this.$emit('update:show', false);
	  	}
	  },
	  watch: { }
	}
</script>
